import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { ICellEditorParams } from "ag-grid-community";
import { NumberInput } from "@jsq/ds/core";
import { ownershipPercentEditor } from "./styles_vanilla.css";

export const OwnershipPercentCellEditor = forwardRef(function OwnershipPercentCellEditor(
  params: ICellEditorParams,
  ref,
) {
  const containerRef = useRef<HTMLDivElement>(null);
  const [value, setValue] = useState(params.value != null ? String(params.value) : "");

  useImperativeHandle(ref, () => ({
    getValue: () => {
      if (value === "") return null;
      const n = parseFloat(value);
      return isNaN(n) ? null : n;
    },
  }));

  useEffect(() => {
    const input = containerRef.current?.querySelector("input");
    input?.focus();
    input?.select();
  }, []);

  return (
    <div ref={containerRef} className={ownershipPercentEditor}>
      <NumberInput min={0} max={100} value={value} onSetValue={setValue} hideSteps />
    </div>
  );
});
